<script setup lang="ts">
/**
 * ScrollableTextarea - A VTextarea wrapper that remains scrollable even when disabled
 *
 * @description This component extends Vuetify's VTextarea to allow scrolling
 * even when the textarea is disabled. Useful for displaying multi-line text
 * that needs to be viewable but not editable.
 *
 * @example
 * ```vue
 * <ScrollableTextarea
 *   v-model="text"
 *   label="Description"
 *   rows="4"
 *   disabled
 * />
 * ```
 *
 * @requires Vuetify's VTextarea component
 */

import { useSnackbarStore } from '@/store/snackbar'

const snackbarStore = useSnackbarStore()

// Get all attributes passed to component
const attrs = useAttrs()

</script>

<template>
  <VTextarea
    v-bind="$attrs"
    :disabled="true"
    class="disabled-scrollable"
  >
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </VTextarea>
</template>

<style lang="scss">
.disabled-scrollable {
  .v-field--disabled .v-field__input {
    pointer-events: auto !important;
    cursor: default;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  }
  .v-field--disabled textarea {
    pointer-events: auto !important;
    cursor: default;
    resize: none;
  }
}
</style>
